"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../../index");
const ethermint_1 = require("../../util/ethermint");
const wallet_1 = require("../../wallet");
const ethers_1 = require("ethers");
const error_1 = require("../metamask/error");
const tx_1 = require("cosmjs-types/cosmos/tx/v1beta1/tx");
const codec_1 = require("../../codec");
const amino_1 = require("@cosmjs/amino");
const eip712_1 = require("../../util/eip712");
const provider_1 = require("../../util/provider");
const legacyEIP712_1 = require("../../util/legacyEIP712");
const network_1 = require("../../util/network");
const blockchain_1 = require("../../util/blockchain");
const constant_1 = require("../../constant");
const eip6963Provider_1 = require("../eip6963Provider");
const constant_2 = require("../../constant");
const generic_1 = require("../../util/generic");
class RainbowKitAccount extends eip6963Provider_1.Eip6963Provider {
    static createRainbowKitSigner(rainbowKit, evmChainId, pubKeyBase64, addressOptions) {
        const evmHexAddress = index_1.AddressUtils.ETHAddress.publicKeyToAddress(Buffer.from(pubKeyBase64, "base64"), addressOptions);
        const signDirect = (_, doc) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const txBody = tx_1.TxBody.decode(doc.bodyBytes);
            const authInfo = tx_1.AuthInfo.decode(doc.authInfoBytes);
            const msgs = txBody.messages.map(message => {
                const msg = codec_1.registry.decode(Object.assign({}, message));
                return {
                    typeUrl: message.typeUrl,
                    value: msg,
                };
            });
            const fee = {
                amount: (_b = (_a = authInfo.fee) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : [],
                gas: (_d = (_c = authInfo.fee) === null || _c === void 0 ? void 0 : _c.gasLimit.toString()) !== null && _d !== void 0 ? _d : "0",
            };
            const aminoMsgs = msgs.map(msg => index_1.AminoTypesMap.toAmino(msg));
            const sig = yield rainbowKit.signEip712(evmHexAddress, doc.accountNumber.toString(), evmChainId, aminoMsgs, fee, txBody.memo, authInfo.signerInfos[0].sequence.toString());
            const sigBz = Uint8Array.from(Buffer.from(sig, 'hex'));
            return {
                signed: doc,
                signature: {
                    pub_key: {
                        type: ethermint_1.ETH_SECP256K1_TYPE,
                        value: pubKeyBase64,
                    },
                    // Remove recovery `v` from signature
                    signature: Buffer.from(sigBz.slice(0, -1)).toString('base64'),
                },
            };
        });
        const signAmino = (_, doc) => __awaiter(this, void 0, void 0, function* () {
            const { account_number, msgs, fee, memo, sequence } = doc;
            const sig = yield rainbowKit.signEip712(evmHexAddress, account_number, evmChainId, msgs, fee, memo, sequence);
            const sigBz = Uint8Array.from(Buffer.from(sig, 'hex'));
            return {
                signed: doc,
                signature: {
                    pub_key: {
                        type: ethermint_1.ETH_SECP256K1_TYPE,
                        value: pubKeyBase64,
                    },
                    // Remove recovery `v` from signature
                    signature: Buffer.from(sigBz.slice(0, -1)).toString('base64'),
                },
            };
        });
        const signLegacyEip712 = (signerAddress, doc) => __awaiter(this, void 0, void 0, function* () {
            const { account_number, chain_id, msgs, fee, memo, sequence } = doc;
            // Only MsgMergeAccount will have an Eth address signer, other generic transaction will be cosmos address signer
            // FeePayer here is only used for legacy EIP-712
            const feePayer = index_1.AminoTypesMap.fromAmino(msgs[0]).typeUrl === codec_1.TxTypes.MsgMergeAccount ? index_1.AddressUtils.ETHAddress.publicKeyToBech32Address(Buffer.from(pubKeyBase64, "base64"), addressOptions) : signerAddress;
            const sig = yield rainbowKit.signEip712(evmHexAddress, account_number, chain_id, msgs, fee, memo, sequence, feePayer);
            return {
                signed: doc,
                signature: {
                    pub_key: {
                        type: ethermint_1.ETH_SECP256K1_TYPE,
                        value: pubKeyBase64,
                    },
                    signature: Buffer.from(sig, 'hex').toString('base64'),
                },
                feePayer,
            };
        });
        const getAccounts = () => __awaiter(this, void 0, void 0, function* () {
            const address = yield rainbowKit.defaultAccount();
            return [
                {
                    // Possible to change to "ethsecp256k1" ?
                    algo: "secp256k1",
                    address,
                    pubkey: Uint8Array.from(Buffer.from(pubKeyBase64, 'base64')),
                },
            ];
        });
        const sendEvmTransaction = (api, req) => __awaiter(this, void 0, void 0, function* () {
            try {
                const request = yield (0, ethermint_1.populateEvmTransactionDetails)(api, req);
                const response = yield rainbowKit.sendEvmTransaction(request);
                return response;
            }
            catch (error) {
                console.error(error);
                throw ((0, error_1.parseEvmError)(error));
            }
        });
        const signMessage = (address, message) => __awaiter(this, void 0, void 0, function* () {
            return rainbowKit.personalSign(address, message);
        });
        return {
            type: wallet_1.CarbonSignerTypes.BrowserInjected,
            legacyEip712SignMode: rainbowKit.legacyEip712SignMode,
            signDirect,
            signAmino,
            getAccounts,
            signLegacyEip712,
            sendEvmTransaction,
            signMessage,
        };
    }
    constructor(provider, legacyEip712SignMode = false) {
        super();
        this.legacyEip712SignMode = legacyEip712SignMode;
        this.blockchain = 'Ethereum';
        this.provider = provider;
    }
    getApi() {
        return this.provider;
    }
    defaultAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            const rainbowKitAPI = this.getApi();
            const accounts = (yield rainbowKitAPI.request({ method: "eth_requestAccounts" }));
            const [defaultAccount] = accounts;
            if (!defaultAccount) {
                throw new Error("No default account, please create one first");
            }
            return defaultAccount;
        });
    }
    syncBlockchain() {
        return __awaiter(this, void 0, void 0, function* () {
            const rainbowKitApi = this.getApi();
            const chainIdHex = (yield (rainbowKitApi === null || rainbowKitApi === void 0 ? void 0 : rainbowKitApi.request({ method: "eth_chainId" })));
            const chainId = chainIdHex ? parseInt(chainIdHex, 16) : undefined;
            const blockchain = (0, blockchain_1.getBlockchainFromChainV2)(chainId);
            this.blockchain = blockchain;
            return { chainId, blockchain };
        });
    }
    static getRequiredChainId(network, blockchain = 'Ethereum') {
        if (blockchain === "Carbon") {
            return Number((0, ethermint_1.parseChainId)(constant_1.CarbonEvmChainIDs[network]));
        }
        if (network === constant_1.Network.MainNet) {
            switch (blockchain) {
                case 'Binance Smart Chain':
                    return 56;
                case 'Arbitrum':
                    return 42161;
                case 'Polygon':
                    return 137;
                case 'OKC':
                    return 66;
                default:
                    return 1;
            }
        }
        switch (blockchain) {
            case 'Binance Smart Chain':
                return 97;
            case 'Arbitrum':
                return 421611;
            case 'Polygon':
                return 80001;
            case 'OKC':
                return 65;
            default:
                return 5;
        }
    }
    static getCarbonEvmNetworkParams(network) {
        switch (network) {
            case constant_1.Network.LocalHost:
                return constant_2.CARBON_EVM_LOCALHOST;
            case constant_1.Network.DevNet:
                return constant_2.CARBON_EVM_DEVNET;
            case constant_1.Network.TestNet:
                return constant_2.CARBON_EVM_TESTNET;
            default:
                return constant_2.CARBON_EVM_MAINNET;
        }
    }
    static getNetworkParams(network, blockchain = 'Ethereum') {
        if (blockchain === 'Carbon') {
            return RainbowKitAccount.getCarbonEvmNetworkParams(network);
        }
        if (network === constant_1.Network.MainNet) {
            switch (blockchain) {
                case 'Binance Smart Chain':
                    return constant_2.BSC_MAINNET;
                case 'Arbitrum':
                    return constant_2.ARBITRUM_MAINNET;
                case 'Polygon':
                    return constant_2.POLYGON_MAINNET;
                case 'OKC':
                    return constant_2.OKC_MAINNET;
                default:
                    // should come with Ethereum configs
                    return constant_2.ETH_MAINNET;
            }
        }
        switch (blockchain) {
            case 'Binance Smart Chain':
                return constant_2.BSC_TESTNET;
            case 'Arbitrum':
                return constant_2.ARBITRUM_TESTNET;
            case 'Polygon':
                return constant_2.POLYGON_TESTNET;
            case 'OKC':
                return constant_2.OKC_TESTNET;
            default:
                // should come with Ethereum configs
                return constant_2.ETH_TESTNET;
        }
    }
    isChangeNetworkRequired(blockchain, network) {
        return __awaiter(this, void 0, void 0, function* () {
            const rainbowKitNetwork = yield this.syncBlockchain();
            const requiredChainId = RainbowKitAccount.getRequiredChainId(network, blockchain);
            return rainbowKitNetwork.chainId !== requiredChainId;
        });
    }
    changeNetworkIfRequired(blockchain, network) {
        return __awaiter(this, void 0, void 0, function* () {
            const required = yield this.isChangeNetworkRequired(blockchain, network);
            if (!required)
                return;
            const rainbowKitApi = this.getApi();
            const requiredChainId = `0x${RainbowKitAccount.getRequiredChainId(network, blockchain).toString(16)}`;
            try {
                yield rainbowKitApi.request({ method: 'wallet_switchEthereumChain', params: [{ chainId: requiredChainId }] });
                yield this.syncBlockchain();
            }
            catch (err) {
                // This error code indicates that the chain has not been added.
                try {
                    yield rainbowKitApi.request({
                        method: 'wallet_addEthereumChain',
                        params: [RainbowKitAccount.getNetworkParams(network, blockchain)],
                    });
                    yield this.syncBlockchain();
                }
                catch (err) {
                    throw new Error(`Please switch to ${blockchain} network on the wallet.`);
                }
            }
        });
    }
    verifyNetworkAndConnectedAccount(evmHexAddress, evmChainId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.verifyNetwork(evmChainId);
            yield this.verifyConnectedAccount(evmHexAddress);
        });
    }
    verifyConnectedAccount(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const rainbowKitApi = this.getApi();
            const accounts = (yield rainbowKitApi.request({ method: "eth_requestAccounts" }));
            if (!accounts.find(acc => acc.toLowerCase() === (address === null || address === void 0 ? void 0 : address.toLowerCase())))
                throw new Error(`${address} not connected`);
        });
    }
    verifyNetwork(evmChainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const network = (0, network_1.carbonNetworkFromChainId)(evmChainId);
            yield this.changeNetworkIfRequired("Carbon", network);
        });
    }
    signEip712(evmHexAddress, accountNumber, evmChainId, msgs, fee, memo, sequence, feePayer = '') {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.verifyNetworkAndConnectedAccount(evmHexAddress, (0, ethermint_1.parseChainId)(evmChainId));
            const stdSignDoc = (0, amino_1.makeSignDoc)(msgs, fee, evmChainId, memo, accountNumber, sequence);
            const eip712Tx = this.legacyEip712SignMode ? (0, legacyEIP712_1.legacyConstructEIP712Tx)(Object.assign(Object.assign({}, stdSignDoc), { fee: Object.assign(Object.assign({}, fee), { feePayer }) })) : (0, eip712_1.constructEIP712Tx)(stdSignDoc);
            const ethereum = this.getApi();
            return yield (0, provider_1.signTransactionWrapper)(() => __awaiter(this, void 0, void 0, function* () {
                const signature = yield ethereum.request({
                    method: 'eth_signTypedData_v4',
                    params: [
                        evmHexAddress,
                        JSON.stringify(eip712Tx),
                    ],
                });
                return signature.split('0x')[1];
            }));
        });
    }
    personalSign(address, message) {
        return __awaiter(this, void 0, void 0, function* () {
            const api = this.getApi();
            const ethAddress = ethers_1.ethers.utils.getAddress(address);
            return (yield api.request({
                method: "personal_sign",
                params: [(0, generic_1.appendHexPrefix)(Buffer.from(message, "utf-8").toString("hex")), ethAddress],
            }));
        });
    }
    sendEvmTransaction(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const ethereum = this.getApi();
            const tx = {
                from: req.from,
                to: req.to,
                value: req.value,
                gasPrice: req.gasPrice,
                gas: req.gasLimit,
                data: req.data,
                // type can only be 0 or 1 or 2
                type: `0x${req.type}`,
                chainId: req.chainId,
            };
            const txHash = (yield ethereum.request({
                method: "eth_sendTransaction",
                params: [tx],
            }));
            return txHash;
        });
    }
}
exports.default = RainbowKitAccount;
